import { azureConstants } from '../actions/constants/azureConstants';

const azureData = (state = {}, action: any) => {
	switch (action.type) {
		case azureConstants.GetUserUsageMetricsRequest:
			return {
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case azureConstants.GetUserUsageMetricsSuccess:
			return {
				isLoading: false,
				isSuccess: true,
				isError: false,
				items: action.payload.userMetricDTO
			};
		case azureConstants.GetUserUsageMetricsFailure:
			return {
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};
		default:
			return state;
	}
};

export default azureData;
